import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../libs/api.ts';
import { thunkErrorHandler } from '../../utils.ts';
import {
  TDiiaGetStatusRequest,
  TDiiaGetStatusResponse,
  TDiiaInitializeResponse,
} from '../types.ts';
import { TBaseRequest } from '~/store/types.ts';

export const diiaSignInitialize = createAsyncThunk<TDiiaInitializeResponse, TBaseRequest>(
  'diia/diiaSignInitialize',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/identification/diia/sign/application/${applicationId}/initialize`
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const diiaSignGetStatus = createAsyncThunk<TDiiaGetStatusResponse, TDiiaGetStatusRequest>(
  'diia/diiaSignGetStatus',
  async ({ requestId, applicationId }, { rejectWithValue, signal }) => {
    try {
      const { data } = await api.get(
        `/identification/diia/sign/application/${applicationId}/get-status/${requestId}`,
        {
          signal,
        }
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const diiaSignGetFinalStatus = createAsyncThunk<
  TDiiaGetStatusResponse,
  TDiiaGetStatusRequest
>('diia/diiaSignGetFinalStatus', async ({ applicationId, requestId }, { rejectWithValue }) => {
  try {
    const { data } = await api.get(
      `/identification/diia/sign/application/${applicationId}/get-final-status/${requestId}`
    );

    return data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const diiaSignRetrieveDocs = createAsyncThunk<TDiiaGetStatusResponse, TDiiaGetStatusRequest>(
  'diia/diiaSignRetrieveDocs',
  async ({ applicationId, requestId }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(
        `/identification/diia/sign/application/${applicationId}/retrieve-documents/${requestId}`,
        null
      );

      return data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
